var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.5 0C16.299 0 21 4.70101 21 10.5C21 12.8585 20.2224 15.0354 18.9096 16.7883L23.5711 21.4497C23.7663 21.645 23.7663 21.9616 23.5711 22.1569L22.1569 23.5711C21.9616 23.7663 21.645 23.7663 21.4498 23.5711L16.7883 18.9096C15.0354 20.2224 12.8585 21 10.5 21C4.70101 21 0 16.299 0 10.5C0 4.70101 4.70101 0 10.5 0ZM10.5 3C6.35786 3 3 6.35786 3 10.5C3 14.6421 6.35786 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35786 14.6421 3 10.5 3Z","fill":"url(#paint0_linear)","key":0}),React.createElement("defs",{"key":1},React.createElement("linearGradient",{"id":"paint0_linear","x1":"0","y1":"0","x2":"24.6268","y2":"0.985073","gradientUnits":"userSpaceOnUse"},React.createElement("stop",{"stopColor":"#6366F1"})))]);
}

Search.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Search;

Search.default = Search;
